"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTransparentButton = exports.StyledSecondaryButton = exports.StyledPrimaryButton = exports.StyledAnchor = void 0;
/* eslint-disable no-nested-ternary */
const styled_components_1 = __importStar(require("styled-components"));
const Button_types_1 = require("./Button.types");
const animateShow = (0, styled_components_1.keyframes) `
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
exports.StyledAnchor = styled_components_1.default.a `
  text-decoration: none;
`;
const StyledButton = styled_components_1.default.button `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  transition: 0.25s ease-in-out;
  transition-property: background-color, color;
  cursor: pointer;
  border: none;
  gap: ${({ theme }) => theme.sizes.s.value};
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  flex-direction: ${({ iconPos }) => Button_types_1.ButtonIconPosition[iconPos] === Button_types_1.ButtonIconPosition.Right ? 'row' : 'row-reverse'};

  ${({ theme, size, hasText }) => {
    switch (size) {
        case Button_types_1.ButtonSize.XSmall: {
            return (0, styled_components_1.css) `
          font-family: ${theme.typography.desktop.text.small_bold['font-family'].value};
          font-size: ${theme.typography.desktop.text.small_bold['font-size'].value};
          height: ${theme.sizes.m.value};
          max-width: ${!hasText && theme.sizes.m.value};
          padding: 0 ${hasText ? theme.sizes['2xs'].value : theme.sizes['4xs'].value};

          svg {
            height: ${theme.sizes.s.value};
            width: ${theme.sizes.s.value};
          }
        `;
        }
        case Button_types_1.ButtonSize.Small: {
            return (0, styled_components_1.css) `
          font-family: ${theme.typography.desktop.text['medium-small_bold']['font-family'].value};
          font-size: ${theme.typography.desktop.text['medium-small_bold']['font-size'].value};
          height: ${theme.sizes.l.value};
          max-width: ${!hasText && theme.sizes.l.value};
          padding: 0 ${hasText ? theme.sizes.xs.value : theme.sizes['3xs'].value};

          svg {
            height: ${theme.sizes.ms.value};
            width: ${theme.sizes.ms.value};
          }
        `;
        }
        case Button_types_1.ButtonSize.Large: {
            return (0, styled_components_1.css) `
          font-family: ${theme.typography.desktop.text['medium-small_bold']['font-family'].value};
          font-size: ${theme.typography.desktop.text['medium-small_bold']['font-size'].value};
          height: ${theme.sizes['2xl'].value};
          max-width: ${!hasText && theme.sizes['2xl'].value};
          padding: 0 ${hasText ? `${theme.sizes.s.value}` : `${theme.sizes.xs.value}`};

          svg {
            height: ${theme.sizes.m.value};
            width: ${theme.sizes.m.value};
          }
        `;
        }
        case Button_types_1.ButtonSize.XLarge: {
            return (0, styled_components_1.css) `
          font-family: ${theme.typography.desktop.text.medium_bold['font-family'].value};
          font-size: ${theme.typography.desktop.text.medium_bold['font-size'].value};
          height: ${theme.sizes['3xl'].value};
          max-width: ${!hasText && theme.sizes['3xl'].value};
          padding: 0 ${theme.sizes.s.value};

          svg {
            height: ${theme.sizes.m.value};
            width: ${theme.sizes.m.value};
          }
        `;
        }
        default: {
            return (0, styled_components_1.css) `
          font-family: ${theme.typography.desktop.text['medium-small_bold']['font-family'].value};
          font-size: ${theme.typography.desktop.text['medium-small_bold']['font-size'].value};
          height: ${theme.sizes.xl.value};
          max-width: ${!hasText && theme.sizes.xl.value};
          padding: 0 ${hasText ? `${theme.sizes.s.value}` : `${theme.sizes['2xs'].value}`};

          svg {
            height: ${theme.sizes.m.value};
            width: ${theme.sizes.m.value};
          }
        `;
        }
    }
}}

  &:hover,
  &:focus {
    outline: 0;
  }

  &:disabled {
    cursor: default;
    color: ${({ theme }) => theme.colors.colours.default.white.value};
    background-color: ${({ theme }) => theme.colors.colours.system['disable-light-theme'].value};
  }

  .text-container {
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.sizes['2xs'].value};
    opacity: 1;
    font: inherit;
    &.invisible {
      opacity: 0;
    }
  }

  .secondary-container {
    display: flex;
    justify-content: center;
    align-items: center;
    animation: ${animateShow} 0.25s linear;
    > div {
      gap: 0;
      padding: 0;
    }
  }

  ${({ hasText, hasIcon, isLoading }) => ((!hasText && !hasIcon) || isLoading) &&
    (0, styled_components_1.css) `
      .text-container {
        visibility: hidden;
      }
      .secondary-container {
        position: absolute;
      }
    `};
`;
exports.StyledPrimaryButton = (0, styled_components_1.default)(StyledButton) `
  background-color: ${({ isNegative, theme, color }) => isNegative
    ? theme.colors.colours.default.white.value
    : color === Button_types_1.ButtonColor.DigitalBlack
        ? theme.colors.colours.default['digital-black'].value
        : theme.colors.theme[color].value};
  color: ${({ isNegative, theme, color }) => isNegative
    ? color === Button_types_1.ButtonColor.DigitalBlack
        ? theme.colors.colours.default['digital-black'].value
        : theme.colors.theme[color].value
    : theme.colors.colours.default.white.value};
  border: 1px solid ${({ theme }) => theme.colors.colours.default.transparent.value};

  &:hover {
    filter: brightness(${({ isNegative }) => (isNegative ? '95%' : '140%')});
    > div:first-child {
      filter: brightness(70%);
    }
  }

  &:active {
    filter: brightness(${({ isNegative }) => (isNegative ? '90%' : '170%')});
    > div:first-child {
      filter: brightness(60%);
    }
  }

  &:disabled {
    ${({ isNegative, theme }) => isNegative &&
    (0, styled_components_1.css) `
        background-color: ${theme.colors.colours.system['disable-dark-theme'].value};
        color: ${theme.colors.colours.system['disable-dark-theme'].value};
        &:hover {
          background-color: ${theme.colors.colours.system['disable-dark-theme'].value};
          color: ${theme.colors.colours.system['disable-dark-theme'].value};
        }
        svg {
          fill: ${theme.colors.colours.system['disable-dark-theme'].value};
          color: ${theme.colors.colours.system['disable-dark-theme'].value};
        }
      `};
  }

  ${({ $selected }) => $selected &&
    (0, styled_components_1.css) `
      opacity: 0.75;
    `};
`;
exports.StyledSecondaryButton = (0, styled_components_1.default)(StyledButton) `
  background-color: ${({ theme }) => theme.colors.colours.default.transparent.value};
  color: ${({ isNegative, theme, color }) => isNegative
    ? theme.colors.colours.default.white.value
    : color === Button_types_1.ButtonColor.DigitalBlack
        ? theme.colors.colours.default['digital-black'].value
        : theme.colors.theme[color].value};
  border: 1px solid
    ${({ isNegative, theme, color }) => isNegative
    ? theme.colors.colours.default.white.value
    : color === Button_types_1.ButtonColor.DigitalBlack
        ? theme.colors.colours.default['digital-black'].value
        : theme.colors.theme[color].value};
  &:hover {
    background-color: ${({ isNegative, theme }) => isNegative
    ? theme.colors.colours.overlay.white[5].value
    : theme.colors.colours.overlay['digital-black'][5].value};
  }
  &:active {
    background-color: ${({ isNegative, theme }) => isNegative
    ? theme.colors.colours.overlay.white[10].value
    : theme.colors.colours.overlay['digital-black'][10].value};
  }
  &:disabled {
    svg {
      fill: ${({ isNegative, theme }) => isNegative
    ? theme.colors.colours.system['disable-dark-theme'].value
    : theme.colors.colours.system['disable-light-theme'].value};
      color: ${({ isNegative, theme }) => isNegative
    ? theme.colors.colours.system['disable-dark-theme'].value
    : theme.colors.colours.system['disable-light-theme'].value};
    }
    background-color: ${({ theme }) => theme.colors.colours.default.transparent.value};
    border: 1px solid
      ${({ isNegative, theme }) => isNegative
    ? theme.colors.colours.system['disable-dark-theme'].value
    : theme.colors.colours.system['disable-light-theme'].value};
    color: ${({ isNegative, theme }) => isNegative
    ? theme.colors.colours.system['disable-dark-theme'].value
    : theme.colors.colours.system['disable-light-theme'].value};
    &:hover {
      background-color: ${({ theme }) => theme.colors.colours.default.transparent.value};
      border: 1px solid
        ${({ isNegative, theme }) => isNegative
    ? theme.colors.colours.system['disable-dark-theme'].value
    : theme.colors.colours.system['disable-light-theme'].value};
      color: ${({ isNegative, theme }) => isNegative
    ? theme.colors.colours.system['disable-dark-theme'].value
    : theme.colors.colours.system['disable-light-theme'].value};
    }
  }

  ${({ $selected, isNegative, theme }) => $selected &&
    (0, styled_components_1.css) `
      background-color: ${isNegative
        ? theme.colors.colours.overlay.white[10].value
        : theme.colors.colours.overlay['digital-black'][10].value};
    `}
`;
exports.StyledTransparentButton = (0, styled_components_1.default)(StyledButton) `
  background-color: ${({ theme }) => theme.colors.colours.default.transparent.value};

  color: ${({ isNegative, theme, color }) => isNegative
    ? theme.colors.colours.default.white.value
    : color === Button_types_1.ButtonColor.DigitalBlack
        ? theme.colors.colours.default['digital-black'].value
        : theme.colors.theme[color].value};
  &.active {
    background-color: ${({ theme }) => theme.colors.colours.support[40].value};
  }
  &:hover {
    background-color: ${({ isNegative, theme }) => isNegative
    ? theme.colors.colours.overlay.white[5].value
    : theme.colors.colours.overlay['digital-black'][5].value};
  }
  &:active {
    background-color: ${({ isNegative, theme }) => isNegative
    ? theme.colors.colours.overlay.white[10].value
    : theme.colors.colours.overlay['digital-black'][10].value};
  }
  &:disabled {
    svg {
      fill: ${({ isNegative, theme }) => isNegative
    ? theme.colors.colours.system['disable-dark-theme'].value
    : theme.colors.colours.system['disable-light-theme'].value};
      color: ${({ isNegative, theme }) => isNegative
    ? theme.colors.colours.system['disable-dark-theme'].value
    : theme.colors.colours.system['disable-light-theme'].value};
    }
    background-color: ${({ theme }) => theme.colors.colours.default.transparent.value};
    color: ${({ isNegative, theme }) => isNegative
    ? theme.colors.colours.system['disable-dark-theme'].value
    : theme.colors.colours.system['disable-light-theme'].value};
    &:hover {
      background-color: ${({ theme }) => theme.colors.colours.default.transparent.value};
      color: ${({ isNegative, theme }) => isNegative
    ? theme.colors.colours.system['disable-dark-theme'].value
    : theme.colors.colours.system['disable-light-theme'].value};
    }
  }

  ${({ $selected, isNegative, theme }) => $selected &&
    (0, styled_components_1.css) `
      background-color: ${isNegative
        ? theme.colors.colours.overlay.white[10].value
        : theme.colors.colours.overlay['digital-black'][10].value};
    `}
`;
//# sourceMappingURL=Button.styled.js.map